import { render, staticRenderFns } from "./AppDataTable.vue?vue&type=template&id=dd236278&"
import script from "./AppDataTable.vue?vue&type=script&lang=js&"
export * from "./AppDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports